import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 8v3a1 1 0 0 0 1 1h3","key":"svg-0"}],["path",{"d":"M7 8v8","key":"svg-1"}],["path",{"d":"M17 8v3a1 1 0 0 0 1 1h3","key":"svg-2"}],["path",{"d":"M21 8v8","key":"svg-3"}],["path",{"d":"M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0","key":"svg-4"}]]

const IconError404 = createReactComponent('outline', 'error-404', 'Error404', __iconNode);

export default IconError404;